import React from 'react';
import { Box, Typography } from '@mui/material';

interface ErrorStatusProps {
	error: string;
}

export default function ErrorStatus({ error }: ErrorStatusProps) {
	return (
		<Box textAlign="center" py={4}>
			<Typography variant="h4" gutterBottom color="error.main">
				⚠️ Error
			</Typography>
			<Typography variant="h6" color="textSecondary" mb={3}>
				{error}
			</Typography>
			<Typography variant="body2" color="textSecondary">
				Please contact support if this issue persists.
			</Typography>
		</Box>
	);
}
